<div class="transport-options-editor no-field-space">
    <sc-padding>
        <form [formGroup]="optionFormGroup">
            <mat-slide-toggle formControlName="optional" name="optional">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.optional"></sc-dictionary-label>
            </mat-slide-toggle>
            <sc-content-spacer vertical></sc-content-spacer>
            <mat-form-field *ngIf="showMinimumSelectedOptions" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.minimum-selected-options"></sc-dictionary-label>
                </mat-label>
                <input matInput appPositiveInteger type="number" min="0" formControlName="minimumSelectedOptions"
                    name="minimumSelectedOptions" [required]="true" />
            </mat-form-field>
        </form>
    </sc-padding>
</div>
